import {
  removeRefreshToken,
  setAccessToken,
  removeAuthProvider,
} from 'utils/auth/tokens';
import { Routing } from 'global/routing';

export function logout(): void {
  setAccessToken(null);
  removeRefreshToken();
  removeAuthProvider();
  window.location.href = Routing.LOGIN.getPath();
}
